import { isOwner } from 'entities';

import { CalendarSyncIcon } from 'components/Icons';

import { registerTaskOption } from '../options';

import { TaskDateChangeModal } from './TaskDateChangeModal';

export default registerTaskOption({
  Icon: CalendarSyncIcon,

  getLabel: (t) => t('answer-date-changes'),

  modal: 'ANSWER_DATE_CHANGE',
  overlay: TaskDateChangeModal,

  shortcutKey: 'D',

  useOption: ({ task, openModal, loggedUser, project }) => {
    const isEnabled = [
      !!task.dateChangeRequest,
      isOwner(project, loggedUser),
      //
    ].every(Boolean);

    return {
      action: () => openModal('ANSWER_DATE_CHANGE'),
      isEnabled,
    };
  },
});
